export default __webpack_public_path__ + "static/media/xflix.9b91be8c.png";